module.exports = __webpack_public_path__ + "img/panelView_strong_Bg_2_3.d0ac64cc.png";